<h2 mat-dialog-title>{{'pass.widgets.types.oneClickPay' | translate}}</h2>

<mat-dialog-content>
  <div class="pt-2 pb-3">
    <section class="mt-1 mb-3 rounded m-auto w-100" id="section" >
      <form [formGroup]="oneClickPayEditForm">

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{'pass.name' | translate}}</mat-label>
          <input formControlName="name" type="text" matInput placeholder="{{'pass.name' | translate}}">
        </mat-form-field>

        <div class="d-flex flex-row">
          <div class="pe-2 flex-grow-1">
            <div class="input-group">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{'pass.oneClickPay.buttonLabel' | translate}}</mat-label>
                <mat-select formControlName="buttonLabel" required>
                  @for (option of buttonLabelOptions; track option) {
                    <mat-option value="{{option}}" ><span translate>pass.oneClickPay.{{option}}</span></mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="ps-2 flex-grow-1">
            <div class="input-group">

              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{'pass.style' | translate}}</mat-label>
                <mat-select formControlName="style" required>
                  <mat-option value="button" >{{'pass.oneClickPay.button' |  translate}}</mat-option>
                  <mat-option value="images" >{{'pass.oneClickPay.images' | translate}}</mat-option>
                </mat-select>
              </mat-form-field>

            </div>
          </div>
        </div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{'pass.oneClickPay.successText' | translate}}</mat-label>
          <input formControlName="successText" type="text" matInput placeholder="{{'pass.oneClickPay.successText' | translate}}">
        </mat-form-field>

        <div class="d-flex flex-row justify-content-between align-items-center">
          <span class="text-muted">{{'pass.oneClickPay.items' | translate}}</span>

          <div class="d-flex flex-row justify-content-between align-items-center">
            <!-- <button mat-button class="secondary-gray-button my-3" id="btn-add" (click)="deleteAllItems()" [disabled]="allproperties?.length == 0">
            <mat-icon>close</mat-icon> {{'delete' | translate}}
          </button> -->

          <button mat-button class="secondary-gray-button my-1 ms-2" id="btn-add-composed" [disabled]="styleClickPay=='button' && allItems?.length>0" (click)="addItem()">
            <mat-icon>add_circle</mat-icon> {{'add' | translate}}
          </button>
        </div>


      </div>
      <mat-card class="mb-4">
        <mat-card-content>

          <div class="p-2">
            @if (allItems?.length==0) {
              <div>{{'empty' | translate}}</div>
            }

            <div class="list-group">
              @for (item of allItems; track item; let index = $index) {
                <div class="list-group-item">
                  <div class="d-flex flex-row justify-content-between align-items-center ">
                    <div class="d-flex flex-column">
                      <span style="font-size: 1.1em;">{{item.title}}</span>
                      <span style="font-size: 0.8em;" class="text-muted">
                        {{item?.price?.amount}}
                        @if (item?.price?.currency == 'euro' ) {
                          <mat-icon style="font-size:12px; height:10px;">euro</mat-icon>
                        }
                        @if (item?.price?.currency == 'pound' ) {
                          <mat-icon style="font-size:12px; height:10px;">currency_pound</mat-icon>
                        }
                      </span>
                    </div>
                    <div class="d-flex flex-row">
                      <button mat-icon-button (click)="editItem(item, index);" >
                        <span class="material-symbols-outlined">edit</span>
                      </button>
                      <button mat-icon-button style="color:var(--warmOrange);" (click)="deleteItem(item, index);" >
                        <span class="material-symbols-outlined">delete</span>
                      </button>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>

        </mat-card-content>
      </mat-card>

      <!-- <div *ngIf="userHasBetaWidgetRole" [app-widget-styling] = "{'form': oneClickPayEditForm.value}" (returnChanges)="returnChangesStyle($event)"></div> -->

    </form>
  </section>
  <div [app-widget-edit-filters] = "{'form': oneClickPayEditForm.value}" (returnChanges)="returnChangesFilters($event)"></div>
</div>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button style="color:var(--warmOrange);" [mat-dialog-close]="oldData" >{{'cancel' | translate}}</button>
  <button mat-button class="orange-button" (click)="saveChanges();"  >{{'apply' | translate}}</button>
</mat-dialog-actions>
